import { Colors } from './Colors';

const highlightedBorder = { border: '0.15rem solid ' + Colors.neutral, borderRadius: '0.5rem' };

export const Styles = {
    highlightedBorder: highlightedBorder,
};
